<template>
  <div class=" w-100 pt-2 service_offers">
    <div v-if="isLoader" class="py-4 pb-5">
      <tvm-pre-loader />
    </div>
    <div v-if="serviceOffersData != null && serviceOffersData.length === 0 && !isLoader" class="pt-4 pb-0 text-center">
      <h6>Currently there are no coupons available. Please skip and continue.</h6>
    </div>

    <div class="px-3 position-relative" v-if="isNewDesign">
      <VSlickCarousel v-if="serviceOffersData != null && serviceOffersData.length" ref="slick"
        class="service__types__list" v-bind="slickOptions">
        <template #nextArrow="arrowSlotProps">
          <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow"
            :style="getArrowStyles('right')"></em>
        </template>
        <div v-for="(serviceDescText, index) in serviceOffersData" :key="index"
          class=" p-2 text-center position-relative">
          <div :class="[{ disabledContent: !isLastIndex }]" class="bg-white h-100 p-1 rounded-box" :style="{
            border: serviceDescText.isSelected
              ? '2px solid ' + primaryColor
              : '0px solid ' + (chatThemeSettings?.borderColor || '#eee'),
          }" :title="serviceDescText.description ? serviceDescText.description : ''"
            @click.prevent="onCouponSelected(serviceDescText, index)">
            <!-- apple wallet -->
            <a class="ai_offer_img">
              <span class="">
                <img
                  :src="`https://service.secureoffersites.com/images/getlibraryimage?fileNameOrId=${serviceDescText.imageId}&amp`"
                  class="img-fluid" alt="serviceDescText" />
              </span>
              <div class="card-min-height mt-3">
                <p v-if="serviceDescText.preText" class="service__types__btn__title text-capitalize text-dark">
                  <span v-html="serviceDescText.preText" />
                </p>

                <p v-if="serviceDescText.offerText1" class="ft-12  text-capitalize text-dark theme-text-color mb-0">
                  <span>
                    <b class="_theme_font_bold" v-html="serviceDescText.offerText1" />
                  </span>
                </p>
                <p v-if="serviceDescText.offerText2" class="service__types__btn__title text-capitalize text-dark ft-13">
                  <span v-html="serviceDescText.offerText2" />
                </p>
                <p v-if="serviceDescText.offerText3" class="service__types__btn__title text-dark">
                  <span>
                    <span v-html="serviceDescText.offerText3" />
                  </span>
                </p>
              </div>
              <div class="text-center py-1 mb-3" style="line-height: 0.5">
                <span :style="{ color: primaryColor }" class="no-hover ft-13  cursor-pointer color-black text-underline"
                  @click.prevent="viewDetails(serviceDescText)">View
                  Details</span>
              </div>
            </a>
            <!-- apple wallet -->
          </div>

        </div>
        <template #prevArrow="arrowSlotProps">
          <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow"
            :style="getArrowStyles('left')"></em>
        </template>
      </VSlickCarousel>
    </div>
    <div v-else>
      <VSlickCarousel v-if="serviceOffersData != null && serviceOffersData.length" ref="slick"
        class="service__types__list" v-bind="slickOptions">
        <template #nextArrow="arrowSlotProps">
          <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow"
            :style="getArrowStyles('right')"></em>
        </template>
        <div v-for="(serviceDescText, index) in serviceOffersData" :key="index"
          class="service__types__list__item p-1 text-center position-relative">
          <div :class="[{ disabledContent: !isLastIndex }]" class="service__types__btn__cont p-1 rounded-box" :style="{
            border: serviceDescText.isSelected
              ? '2px solid ' + primaryColor
              : '1px solid ' + (chatThemeSettings?.borderColor || '#eee'),
          }" :title="serviceDescText.description ? serviceDescText.description : ''"
            @click.prevent="onCouponSelected(serviceDescText, index)">
            <!-- apple wallet -->
            <a class="service__types__btn">
              <span class="service__types__btn__iconBox">
                <img
                  :src="`https://service.secureoffersites.com/images/getlibraryimage?fileNameOrId=${serviceDescText.imageId}&amp;height=60`"
                  class="img-fluid" alt="serviceDescText" />
              </span>
              <div class="card-min-height">
                <p v-if="serviceDescText.preText" class="service__types__btn__title text-capitalize text-dark">
                  <span v-html="serviceDescText.preText" />
                </p>

                <p v-if="serviceDescText.offerText1" class="ft-12  text-capitalize text-dark theme-text-color mb-0">
                  <span>
                    <b v-html="serviceDescText.offerText1" />
                  </span>
                </p>
                <p v-if="serviceDescText.offerText2" class="service__types__btn__title text-capitalize text-dark">
                  <span v-html="serviceDescText.offerText2" />
                </p>
                <p v-if="serviceDescText.offerText3" class="service__types__btn__title text-dark">
                  <span v-if="serviceDescText.offerText3.length > 20" :title="serviceDescText.offerText3">
                    <span v-html="trucate(serviceDescText.offerText3)" />
                  </span>
                  <span v-else>
                    <span v-html="serviceDescText.offerText3" />
                  </span>
                </p>
              </div>
            </a>
            <!-- apple wallet -->
          </div>
          <div class="text-center py-1 view-details" style="line-height: 0.5">
            <span :style="{ color: primaryColor }" class="ft-10 theme-text-color"
              @click.prevent="viewDetails(serviceDescText)">View Details</span>
          </div>
        </div>
        <template #prevArrow="arrowSlotProps">
          <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow"
            :style="getArrowStyles('left')"></em>
        </template>
      </VSlickCarousel>
    </div>

    <div class="w-100">
      <div class="mb-2 d-flex flex-wrap align-items-center w-100">
        <div class="min-40">
          <h6 v-if="offerText2" class="list__block pl-2 ft-13 m-0">
            <b> Selected Dealer Special: </b> <span v-html="offerText2" />
          </h6>
        </div>
      </div>
      <ul v-if="buttons != null && buttons.length"
        class="list-unstyled service__types__list d-flex justify-content-center">
        <li v-for="(button, index) in buttons" :key="index" :class="isLastIndex ? 'mb-4' : 'mb-0'">
          <div class="d-flex flex-wrap justify-content-center">
            <button v-if="isLastIndex"
              class="btn bgcolor-primary mb-2 rounded-buttons mx-2 text-white service__chips__btn"
              :disabled="(selectedCoupon.length == 0 && button.code === 'cnfm') || isDisableBtn"
              @click.once="optionclick(button)">
              {{ button.name }}
            </button>
          </div>
        </li>
      </ul>
    </div>

    <!-- custom modal -->
    <template v-if="viewDetailsModal">
      <div id="viewDetailsModal" class="modal" :style="{ display: viewDetailsModal ? 'block' : 'none' }">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header align-items-center">
              <h6 class="m-0 _theme_font_bold">Disclosure</h6>
              <div>
                <button type="button" aria-label="Close" class="close" @click.prevent="viewDetailsModal = false">
                  ×
                </button>
              </div>
            </div>

            <div class="p-3 scroll-wrap">
              <p v-if="viewDetailsData.disclaimerText">
                <span v-html="viewDetailsData.disclaimerText" />
              </p>
              <p v-if="viewDetailsData.formattedEndDate" class="m-0">
                - Expires:
                <b class="color-primary theme-text-color">{{ viewDetailsData.formattedEndDate }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop show" />
    </template>
    <!-- end custom modal -->
  </div>
</template>
<script src="./TvmDealerSpecials.js"></script>
<style scoped>
.service__types .slick-slide img {
  object-fit: contain;
}


.service__types__list .slick-track {
  display: flex !important;
}

.service__types__list .slick-slide {
  height: inherit !important;
}

.card-min-height {
  min-height: 110px;
}

.service__types {
  width: 100%;
  height: auto;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}

.service__types__list {
  width: 100%;
  padding: 0 20px;
  margin: 0 0 5px 0;
}

.service__types__list__item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.service__types__btn__cont {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.service__types__btn {
  width: 100%;
  height: 100%;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  padding: 0;
  border: 0 !important;
  background: none !important;
  outline: 0 !important;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}

.ttinfo {
  width: 150px;
  height: auto;
  display: flex;
  position: absolute;
  border: 1px solid red;
  padding: 5px;
}

.service__types__btn__iconBox {
  margin-bottom: 5px;
  margin-right: 0;
  border: 0;
  padding: 2px;
  min-height: 80px;
  display: flex;
}

.service__types__btn__title {
  font-size: 10px;
  font-weight: 400;
  margin: 0;
}

.selected-box {
  background-color: #f5f5f5;
  border: 1px solid;
}

.box-border {
  border: 1px solid #ccc;
}

.active-border {
  border: 3px solid;
}

.slick-list.draggable {
  height: 100%;
}

.box-bottom {
  bottom: 3px;
  width: 90%;
  left: 14px;
}

.service__chips__btn {
  font-size: 12px;
  font-weight: 400;
  padding: 6px 12px;
  min-width: 56px;
  height: 32px;
}

.chat__subSec .service__chips__btn {
  color: #fff !important;
}

.slick-track {
  display: flex !important;
  align-items: center !important;
}

.tooltip.show {
  opacity: 1;
}



.list__block {
  display: inline-block;
  width: 100%;
}

.list__data {
  font-size: 0.7em;
  display: block;
  font-weight: bold;
}

.service__types>>>em.primaryicon-left-arrow.slick-arrow {
  background: #007cc3 !important;
}

.service__types>>>em.primaryicon-right-arrow.slick-arrow {
  background: #007cc3 !important;
}

.service__types>>>em.primaryicon-left-arrow.slick-disabled,
.service__types>>>em.primaryicon-right-arrow.slick-disabled {
  pointer-events: none;
  opacity: 0;
}

.view-details {
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
  margin: auto;
}

.service__types>>>.modal {
  position: absolute !important;
  margin: 10px;
}

.service__types>>>.modal-body {
  padding: 0px;
}

.service__types>>>.modal-header {
  padding: 5px;
}

.service__types>>>.modal-title {
  text-transform: capitalize;
}

.service__types>>>.modal-backdrop {
  position: absolute !important;
}

.service__types>>>.modal button:focus {
  box-shadow: none;
  outline: none;
}



.service__types__btn__cont.disabledContent {
  pointer-events: none !important;
  opacity: 0.9 !important;
}

.modal .scroll-wrap {
  max-height: 50vh;
  overflow-y: auto;
  font-size: 12px;
}

@media (min-width: 1900px) {
  .modal .scroll-wrap {
    font-size: 14px;
  }
}

.min-40 {
  min-height: 40px;
  width: 100%;
}

#chat-widget .v-slick-slider em[disabled=false] {
  display: none !important;
}

.ai_offer_img img {
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  width: 100%;
}

.ai_offer_img .card-min-height {
  min-height: 200px;
}
</style>
